// extracted by mini-css-extract-plugin
export var active = "bn_bd";
export var arrow = "bn_9";
export var button = "bn_b7";
export var buttonMobile = "bn_fk";
export var column = "bn_cc";
export var columns = "bn_cb";
export var container = "bn_h";
export var description = "bn_dx";
export var disclaimer = "bn_cC";
export var disclaimerButton = "bn_ff";
export var disclaimerContainer = "bn_fm";
export var disclaimerText = "bn_fq";
export var fadeBottom = "bn_fp";
export var fadeTop = "bn_fn";
export var featureFooter = "bn_fh";
export var footer = "bn_cS";
export var footerMobile = "bn_fj";
export var heading = "bn_G";
export var highlight = "bn_fg";
export var icon = "bn_bw";
export var iconContainer = "bn_bX";
export var left = "bn_bL";
export var padding = "bn_dN";
export var popular = "bn_dM";
export var prefix = "bn_fd";
export var recommend = "bn_fb";
export var recommended = "bn_fc";
export var right = "bn_bQ";
export var section = "bn_j";
export var show = "bn_L";
export var subHeading = "bn_H";
export var suffix = "bn_dK";
export var title = "bn_d";
export var waveContainer = "bn_fl";
export var waveOne = "bn_q";
export var waveThree = "bn_cH";
export var waveTwo = "bn_n";
export var waves = "bn_cG";